module.exports = __webpack_public_path__ + "img/ic_newclass.daa2c2d6.svg";